import { ContentSection } from "@components/ContentSection";
import { CARDS_PER_PAGE } from "./lib/constants";

export const RenderContentSection = ({ contentSections, showContentFirst, prodIndex }) => {
  // If they want to show the first content block above the product cards
  // we need to remove it from the array and place it above the product cards
  if (showContentFirst) {
    if (prodIndex === 0) return <ContentSection section={contentSections[0]} />;
    const sectionsWithoutFirstSection = contentSections.slice(1);

    return sectionsWithoutFirstSection.map((section, index) => {
      if (prodIndex / (index + 1) === CARDS_PER_PAGE) {
        return <ContentSection key={section._id} section={section} />;
      }
    });
  }

  if (!showContentFirst) {
    return contentSections.map((section, index) => {
      // if product index is 24, and section position is 2 (index + 1),
      // it equals 12, so place that section in that spot
      if (prodIndex / (index + 1) === CARDS_PER_PAGE) {
        return <ContentSection key={section._id} section={section} />;
      }
    });
  }
};
